import { useState, useEffect } from 'react';
import { TextField, Button, Stack, Link as MuiLink, Box, Alert } from '@mui/material';
import { Link as RouterLink, useNavigate, useSearchParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import AuthShell from '../components/AuthShell';
import { useAuth } from '../contexts/AuthContext';
import { getErrorMessage, buildErrorSnackbarOptions } from '../utils/errorUtils';

export default function Login() {
    const { login, user } = useAuth();
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const returnTo = params.get('returnTo') || '/';
    const flashMessage = params.get('message');

    useEffect(() => {
        if (user) navigate(returnTo, { replace: true });
    }, [user, returnTo, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email || !password) {
            enqueueSnackbar('Courriel et mot de passe requis', { variant: 'error' });
            return;
        }
        setSubmitting(true);
        try {
            await login(email.trim(), password);
            navigate(returnTo, { replace: true });
        } catch (err) {
            enqueueSnackbar(getErrorMessage(err, 'Connexion impossible'), buildErrorSnackbarOptions(err, closeSnackbar));
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <AuthShell
            title="Connexion"
            subtitle="Accédez à votre portail de commande Amabec."
        >
            {flashMessage ? (
                <Alert severity="info" sx={{ mb: 2 }}>{flashMessage}</Alert>
            ) : null}
            <Box component="form" onSubmit={handleSubmit} noValidate>
                <Stack spacing={2}>
                    <TextField
                        label="Courriel"
                        type="email"
                        autoComplete="email"
                        autoFocus
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <TextField
                        label="Mot de passe"
                        type="password"
                        autoComplete="current-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <Button type="submit" variant="contained" size="large" disabled={submitting}>
                        {submitting ? 'Connexion…' : 'Se connecter'}
                    </Button>
                    <MuiLink component={RouterLink} to="/forgot-password" sx={{ alignSelf: 'flex-end', fontSize: 13 }}>
                        Mot de passe oublié?
                    </MuiLink>
                </Stack>
            </Box>
        </AuthShell>
    );
}
